import validator from "@rjsf/validator-ajv6";
import { Form } from "@rjsf/mui";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { setMessage } from "../../redux/slices/snackbarSlice";
import { useEffect, useState } from "react";
import { setBalancType } from "../../redux/slices/balanceSlice";
import { store } from "../../redux/store";
import RolesSelector from "../../components/userGroups/RolesSelector";
import SearchOnServer from "../../components/form/formComponents/SearchOnServer";
import { setBreadCrumbs } from "../../redux/slices/breadCrumbMeterSlice";
import { Button, Grid, Typography } from "@mui/material";
import BalanceTransferList from "./BalanceTransferList";
import theme from "../../theme";
import { Box } from "@mui/system";
const ObjectFieldTemplate = (props) => {
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="flex-end"
      rowSpacing={3}
      spacing={2}
    >
      {props.properties?.map((element, i) => {
        if (element.name === "meters" || element.name === "balance_type") {
          return (
            <Grid key={element.id} alignItems="center" item xs={12}>
              {element.content}
            </Grid>
          );
        }
        return (
          <Grid key={element.id} alignItems="center" item xs={6}>
            {element.content}
          </Grid>
        );
      })}
    </Grid>
  );
};
const CreateBalance = () => {
  const navigate = useNavigate();
  const { id, balanceId } = useParams();
  const [getCondominiumShow, { isFetching }] =
    store.useLazyCondominiumShowQuery();

  const balance = useSelector((state) => state?.balanceSlice?.balance);
  const [getBalanceShow] = store.useLazyGetBalanceShowQuery();
  const condominiumShow = useSelector(
    (state) => state?.condominiumSlice?.condominiumShow
  );
  const [updatebalance, { isSuccess: updateSuccess }] =
    store.useUpdateBalanceMutation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const balanceTypes = [
    { const: "water" },
    { const: "cooling" },
    { const: "heating" },
    { const: "water_heating" },
  ];

  const [formData, setFormData] = useState({});

  const scm = {
    type: "object",
    properties: {
      name: {
        $id: "5",
        type: "string",
        title: t("name"),
        default: balance?.name ?? "",
      },
      description: {
        $id: "5",
        type: "string",
        title: t("description"),
        default: balance?.description ?? "",
      },
      /* code: {
        $id: "5",
        type: "string",
        title: t("code"),
      }, */
      limit: {
        $id: "5",
        type: "number",
        title: t("limit"),
        default: balance?.limit && balance?.limit,
      },
      balance_type: {
        $id: "5",
        type: "string",
        title: t("balance_type"),
        oneOf: [...balanceTypes],
        default: balance?.balance_type && balance?.balance_type,
      },
      roles: {
        $id: "10",
        type: "array",
        title: t("roles"),
        roles: true,
        multiple: true,
        url: "role",
        default: balance?.roles && balance?.roles,
      },
      meters: {
        $id: "5",
        type: "object",
        update: true,
        properties: {
          in_meters: {
            type: "array",
          },
          out_meters: {
            type: "array",
          },
        },
      },
    },
  };

  useEffect(() => {
    if (!condominiumShow) {
      getCondominiumShow(id);
    }
  }, [condominiumShow]);
  useEffect(() => {
    if (!balance) {
      getBalanceShow(balanceId);
    }
  }, [balance]);

  useEffect(() => {
    if (balance && condominiumShow) {
      dispatch(
        setBreadCrumbs({
          id: condominiumShow?.name,
          balanceId: balance?.code,
        })
      );
    }
    return () => {
      dispatch(setBreadCrumbs(null));
    };
  }, [balance, condominiumShow]);

  const [schema, setSchema] = useState(scm);
  useEffect(() => {}, [formData]);
  useEffect(() => {
    if (formData.balance_type === "water_heating") {
      const props = { ...scm.properties };
      props["delta_t"] = {
        type: "number",
        default: 35,
        title: t("delta_t"),
      };
      props["conversion_value"] = {
        type: "number",
        default: 860,
        title: t("conversion_value"),
      };
      const newSchema = { ...schema, properties: props };
      setSchema(newSchema);
    } else {
      const props = { ...scm.properties };
      delete props.delta_t;
      delete props.conversion_value;
      const newSchema = { ...schema, properties: props };
      setSchema(newSchema);
    }
  }, [formData.balance_type]);

  const fields = {
    transfer: BalanceTransferList,
    serverSearch: RolesSelector,
  };
  const uiSchema = {
    "ui:order": [
      "name",
      "description",
      "code",
      "limit",
      "roles",
      "balance_type",
      "delta_t",
      "conversion_value",
      "meters",
    ],

    "ui:ObjectFieldTemplate": ObjectFieldTemplate,
    roles: {
      "ui:field": "serverSearch",
    },
    "ui:submitButtonOptions": {
      submitText: t("update"),
      props: {
        variant: window?.BUTTON_TYPE,
        color: window?.theme?.buttonText,
      },
    },
    meters: {
      "ui:field": "transfer",
    },
  };

  useEffect(() => {}, [formData]);

  useEffect(() => {
    if (formData.balance_type) {
      switch (formData.balance_type) {
        case "water":
          dispatch(setBalancType(["AFS", "ACS"]));
          break;

        case "cooling":
          dispatch(setBalancType(["Frigorie"]));
          break;
        case "heating":
          dispatch(setBalancType(["Calorie"]));
          break;
        case "water_heating":
          dispatch(setBalancType(["Calorie", "ACS"]));
          break;
      }
    }
  }, [formData?.balance_type]);

  const balanceTypeSelector = (type) => {
    switch (type) {
      case t("water"):
        return "water";

      case t("cooling"):
        return "cooling";
      case t("heating"):
        return "heating";
      case t("water_heating"):
        return "water_heating";
    }
  };

  const onSubmitClick = () => {
    const attributes = {
      /*      condominium_id: +id, */
      name: formData.name,
      description: formData.description,
      in_meters: formData?.meters?.in_meters,
      out_meters: formData?.meters?.out_meters,
      balance_type:
        /* balanceTypeSelector(formData?.balance_type) */ formData?.balance_type,
      code: formData?.code,
      limit: formData?.limit,
      roles: formData?.roles,
      coefficients: {
        delta_t: formData?.delta_t,
        conversion_value: formData?.conversion_value,
      },
    };
    updatebalance({
      attributes: attributes,
      id: balanceId,
    });
  };

  useEffect(() => {
    if (updateSuccess) {
      dispatch(setMessage(t("update_success")));
      navigate(`/condominiums/${id}/balance/${balanceId}`);
    }
  }, [updateSuccess]);

  return (
    <>
      {balance && (
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="h4">{t("update_balance")}</Typography>
          <Form
            schema={schema}
            fields={fields}
            formData={formData}
            onChange={(changeEvent) => setFormData(changeEvent.formData)}
            onSubmit={(values) => onSubmitClick()}
            validator={validator}
            uiSchema={uiSchema}
            /* widgets={widgets} */
            showErrorList={false}
            /*   customValidate={customValidate} */
            noHtml5Validate
          />
        </Box>
      )}
    </>
  );
};
export default CreateBalance;
